import { DriverGroupDto } from '@cargovibe/shared-types';

interface IsDriverGroupDraftDirtyParams {
  activeGroup: DriverGroupDto | null;
  draftName: string;
  draftMemberIds: Set<string>;
}

function haveSameMembers(draftMemberIds: Set<string>, memberIds: string[]): boolean {
  return (
    draftMemberIds.size === memberIds.length &&
    memberIds.every((memberId: string): boolean => draftMemberIds.has(memberId))
  );
}

export function isDriverGroupDraftDirty({
  activeGroup,
  draftName,
  draftMemberIds,
}: IsDriverGroupDraftDirtyParams): boolean {
  return (
    activeGroup !== null &&
    (draftName.trim() !== activeGroup.name ||
      !haveSameMembers(draftMemberIds, activeGroup.memberIds))
  );
}
